export function isMobile() {
	return window.innerWidth <= 768;
}
